import { API_BASE_URL, parseJsonResponse } from './apiConfig'

async function fetchWithTimeout(resource, options = {}, timeout = 10000) {
  const controller = new AbortController()
  const id = setTimeout(() => controller.abort(), timeout)
  try {
    const response = await fetch(resource, {
      ...options,
      signal: controller.signal,
    })
    clearTimeout(id)
    return response
  } catch (error) {
    clearTimeout(id)
    throw error
  }
}

export async function fetchOverallMetrics() {
  const response = await fetchWithTimeout(`${API_BASE_URL}/metrics/overall`, {
    method: 'GET',
    headers: { 'Content-Type': 'application/json' },
  })

  if (!response.ok) {
    throw new Error('Failed to fetch metrics')
  }

  return parseJsonResponse(response, 'Failed to fetch metrics')
}

export async function fetchStatusDistribution() {
  const response = await fetchWithTimeout(`${API_BASE_URL}/metrics/status-distribution`, {
    method: 'GET',
    headers: { 'Content-Type': 'application/json' },
  })

  if (!response.ok) {
    throw new Error('Failed to fetch status distribution')
  }

  return parseJsonResponse(response, 'Failed to fetch status distribution')
}

export async function fetchDailyVisitors() {
  const response = await fetchWithTimeout(`${API_BASE_URL}/metrics/daily-visitors`, {
    method: 'GET',
    headers: { 'Content-Type': 'application/json' },
  })

  if (!response.ok) {
    throw new Error('Failed to fetch daily visitors')
  }

  return parseJsonResponse(response, 'Failed to fetch daily visitors')
}

export async function fetchDepartmentWiseVisitors() {
  const response = await fetchWithTimeout(`${API_BASE_URL}/metrics/department-wise`, {
    method: 'GET',
    headers: { 'Content-Type': 'application/json' },
  })

  if (!response.ok) {
    throw new Error('Failed to fetch department-wise visitors')
  }

  return parseJsonResponse(response, 'Failed to fetch department-wise visitors')
}

export async function fetchCheckInOutStats() {
  const response = await fetchWithTimeout(`${API_BASE_URL}/metrics/check-in-out-stats`, {
    method: 'GET',
    headers: { 'Content-Type': 'application/json' },
  })

  if (!response.ok) {
    throw new Error('Failed to fetch check-in/out stats')
  }

  return parseJsonResponse(response, 'Failed to fetch check-in/out stats')
}
